var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0_2039_94164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2039_94164",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2039_94164",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2039_94164",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABa0lEQVRoBe1ZQU4CQRAEDz4D8B+GA4hPRH2E3/EIIRjPylkCVdFO+jIJuzWDAauTzjS73dXTVcNlZzCwmQEz0IeBCYpe4Fv4N/zQ01lLjGf4GH4We0SXHbzvpkt1X8B8aD3BBA1abD6G4hCjlkPw2ESzFeIZ/Pa34Wt6Fzmllbk01s7ha3jkPiFuZjyv0Yibz3aHH2/weF9amcPcbBwi8jf5Re04/2GD+Ro9iBUDsMfJNjw58yeRTcK61kZdae2FfVNCu5TnHuCvlbICVkBkwEdIJFAutwIyhSKAFRAJlMutgEyhCGAFRALlcisgUygCWAGRQLncCsgUigBWQCRQLrcCMoUiwL9TYJ8Iq/1xN6Bzj3hWXLsq8JGQ7lOshtME8J7i6iHvsuIz+Boxr4QUJVi7gBMrcJeIm9kYyLwGima1109gN71iIjNkvcUQ3Dxvas5iZIlS8zoo39p0VYS1xCBWc+bRw2YGro6BI780uex+Aa59AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobIcon);
export default __webpack_public_path__ + "static/media/MobIcon.0c2af0e14424eb5ec8472968be337a17.svg";
export { ForwardRef as ReactComponent };